import { Field as HeadlessUIField } from "@headlessui/react";
import tw, { styled } from "twin.macro";

const Field = styled(HeadlessUIField)(tw``);

export default Field;
